module.exports = __webpack_public_path__ + "static/media/nice3.a7ad029d.wav";